import pkg from '../package.json';
import Player from './models/player';
import Metadata from './models/metadata';
import Embed from './views/embed';
import {
  DEFAULTS,
  CONFIG_NAMESPACE,
  MODAL_LAYER_ID
} from './constants';
import {
  showLog,
  showWarn,
  showError
} from './logger';

const {$} = Voonto;

Voonto.ready.then((app) => {
  const config = app.lookup(CONFIG_NAMESPACE);
  if (!config.serviceUrl) {
    showError(`service url is not defined within ${CONFIG_NAMESPACE}`);
    throw Error(`[VideoPlayer] service url is not defined within ${CONFIG_NAMESPACE}`);
  }

  if (!$(`#${MODAL_LAYER_ID}`).length) {
    $('body').append(`<div id="${MODAL_LAYER_ID}"></div>`);
  }

  _init(config);

  app.on('voonto:reload', function (event, context$) {
    _init(config, context$);
  });
  app.on('videoplayer:refresh', function (event, context$) {
    _init(config, context$);
  });

  // subscribe to visibility change events
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      showLog('index.js::visibilitychange::hidden');
      $('video').each(function() {
        let video$ = $(this).get(0);
        // pause video
        if (video$ && !video$.paused) {
          return video$.pause();
        }
        // pause ad
        return setTimeout(()  => {
          if (video$
            && typeof videojs !== 'undefined'
            && videojs(video$.id)
            && videojs(video$.id).ima3
            && videojs(video$.id).ima3.adsManager) {
            videojs(video$.id).ima3.adsManager.pause();
          }
        }, 0);
      });
    }
    if (document.visibilityState === 'visible') {
      showLog('index.js::visibilitychange::visible');
    }
  });
});

export const VERSION = pkg.version;

/* Private */

function _init(config, context$) {
  showLog(`index::_init::Version ${VERSION}`);
  $('[data-voc-video-player]', context$).each(function() {
    let container$ = $(this);
    let options = {};

    $.extend(options, DEFAULTS, {
      source:              container$.data('voc-video-player-source'),
      accountname:         container$.data('voc-video-player-accountname'),
      videoid:             container$.data('voc-video-player-videoid'),
      autoplay:            container$.data('voc-video-player-autoplay'),
      author:              container$.data('voc-video-player-author'),
      bumperid:            container$.data('voc-video-player-bumperid'),
      controls:            container$.data('voc-video-player-controls'),
      description:         container$.data('voc-video-player-description'),
      domain:              container$.data('voc-video-player-domain'),
      edition:             container$.data('voc-video-player-edition'),
      link:                container$.data('voc-video-player-link'),
      loop:                container$.data('voc-video-player-loop'),
      longdescription:     container$.data('voc-video-player-longdescription'),
      modallayer:          container$.data('voc-video-player-modallayer'),
      muted:               container$.data('voc-video-player-muted'),
      name:                container$.data('voc-video-player-name'),
      newsid:              container$.data('voc-video-player-newsid'),
      playerid:            container$.data('voc-video-player-playerid'),
      playlistid:          container$.data('voc-video-player-playlistid'),
      playlistorientation: container$.data('voc-video-player-playlistorientation'),
      playsinline:         container$.data('voc-video-player-playsinline'),
      poster:              container$.data('voc-video-player-poster'),
      template:            container$.data('voc-video-player-template'),
      src:                 container$.data('voc-video-player-src'),
      videoad:             container$.data('voc-video-player-videoad'),
      videolive:           container$.data('voc-video-player-videolive')
    });

    let metadata = new Metadata(options, config.serviceUrl);
    let player = new Player(options, config.serviceUrl);
    let embed = new Embed({
      metadata,
      player,
      container$
    });
    embed.fetch();
  });
}



// WEBPACK FOOTER //
// ./src/index.js